import { handleSessionLessApi } from '../../common';

const STOCK_NEWS_API_ENDPOINTS = {
	landing: `flash/market/get_hot_pursuit_data`,
};

export const fetch_hot_pursuit_data = async (Api, sessionLessServer = '', body = {}) => {
	const fetchUrl = `${sessionLessServer}${STOCK_NEWS_API_ENDPOINTS.landing}`;
	const response = await Api.post(fetchUrl, body);
	return handleSessionLessApi(response);
};
